import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const DisableSchedulingDates = MatxLoadable({
    loader: () =>
        import ("./DisableSchedulingDates")
})
const AllDisableSchedulingDates = MatxLoadable({
    loader: () =>
        import ("./AllDisableSchedulingDates")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const DisableSchedulingDatesRoutes = [
    {
        path: "/disable_scheduling_dates",
        component: AllDisableSchedulingDates,
        // settings
    },

];

export default DisableSchedulingDatesRoutes;